import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql: DocumentNode = gql`
fragment DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace on PublishedDatasource {
  id
  name
  description
  vizportalUrlId
  hasExtracts
  extractLastUpdateTime
  isCertified
  certificationNote
  projectVizportalUrlId
  projectName
  owner {
    username
    name
    domain
  }
  certifier {
    username
    name
    domain
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
`;
